import { Component, OnInit } from "@angular/core";
import { NotifierService } from "src/app/_services/notifier.service";
import { APIService } from "src/app/api/api.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-azure-functions",
  templateUrl: "./azure-functions.component.html",
  styleUrls: ["./azure-functions.component.css"],
})
export class AzureFunctionsComponent implements OnInit {
  accountId: string;
  regionId: string;
  resourceGroup: string;
  userId: string = localStorage.getItem('selectedClientList');

  functionsHeader: any = [
    {
      id: "name",
      name: "Name",
    },
    {
      id: "location",
      name: "Location",
    },
    {
      id: "type",
      name: "Type",
    },
    {
      id: "runtime",
      name: "Runtime",
    },
    {
      id: "state",
      name: "State",
    },
    {
      id: "https_url",
      name: "Https URL",
    }
  ];

  tags: any = [
    {
      id: 'Key',
      name: 'Key'
    }, 
    {
      id: 'Value', 
      name: 'Value'
    }
  ];

  currentMessage: any;

  loading: boolean = true;
  destroyed: boolean = false;

  urlPrefix: any = localStorage.getItem("role") == "Admin" ? "admin" : "client";

  functions: any = [];

  constructor(
    private apiService: APIService,
    private notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.accountId = localStorage.getItem("accountId");
    this.regionId = localStorage.getItem("regionId");
    this.resourceGroup = localStorage.getItem("selectedResourceGroup");

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == "regionId") {
        this.regionId = d.value;
        this.load();
      } else if (d.key == "resourceGroup") {
        this.resourceGroup = d.value;
        this.load();
      }
    });
    this.load();
  }
  load() {
    this.loadVMs();
  }

  showTagsModal: any | null = null;
  showTags(data: any) {
    this.showTagsModal = data;
  }

  async loadVMs() {
    this.loading = true;
    this.functions = [];
    this.userId = localStorage.getItem("selectedClientList");

    const data: any = {
      action: "list_azure_functions",
      // user_id: this.urlPrefix == 'admin' && (localStorage.getItem('selectedAccountGroup') == "DevelopmentTestGroup" || localStorage.getItem('selectedAccountGroup') == 'MinfyDevTeam') ? "rakeshkumar.t@minfytech.com" : this.userId,
      user_id: this.userId,
      subscription_id: localStorage.getItem("accountId"),
      resource_group_name: this.resourceGroup,
    };

    const header: any = {
      Authorization: localStorage.getItem("t"),
    };

    const apiUrl: string = `${environment.apiURL}/${this.urlPrefix}/azure/central`;

    let result: any = await this.apiService.postDataPromis(
      apiUrl,
      data,
      header
    );

    if (result.status == "1" || result.s == "1") {
      this.functions = result.azure_functions;
    }

    this.loading = false;
    this.notifier.loading(false);
  }

  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
    this.destroyed = true;
  }
}
